import Header from '../../common/Header/Header';
import './JobIndex.scss';
import { useEffect, useState } from 'react';
import Packages from '../../api/controllers/Packages/Packages';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import Job from './Job';

// JobIndex screen Component
const JobIndex = () => {
  const [groupedPackages, setGroupedPackages] = useState();
  const [error, setError] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getPackages = () => {
    const params = { hubId: hubId, status: 'in_warehouse' };
    Packages.all(params)
      .then(response => {
        setGroupedPackages(Object.groupBy(response?.items, ({ job }) => job?.jobReference));
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getPackages();
  }, []);

  return (
    <div className="jobs_screen">
      <Header title={'Jobs'} rightButton={'home'} />
      <div className="job_list">
        {error && (
          <Error
            errorMessages={error}
            type={'info'}
            errorTitle={
              Array.isArray(error)
                ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
                : ''
            }
          />
        )}
        {!groupedPackages && !error && <LoadingSpinner />}
        {groupedPackages &&
          Object.keys(groupedPackages).map(key => {
            return <Job job={groupedPackages[key]} key={key} />;
          })}
      </div>
    </div>
  );
};

export default JobIndex;
